module.exports = __webpack_public_path__ + "static/img/no-caca.ab100f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/no-caca.png
// module id = 240
// module chunks = 1